'use client';

import { usePathname } from 'next/navigation';
import { Language, languages } from '@/app/i18n/settingsClient';

export const useRemoveLangFromPath = (): string => {
  const pathname = usePathname();

  const path = (() => {
    const sections = pathname.split('/').filter(Boolean);
    if (sections.length === 0) return '/';

    const [couldBeLang, ...rest] = sections;
    if (languages.includes(couldBeLang as Language)) {
      return `/${rest.join('/')}`;
    }
    return pathname;
  })();

  return path.startsWith('/') ? path : `/${path}`;
};
